<app-home-fundamentals-card [type]="cardType" [content]="contentTemplate" [actions]="actionsTemplate">
</app-home-fundamentals-card>

<ng-template #contentTemplate>
    <ng-container *ngIf="incidents$ | async as incidents; else contentLoading">
        <button
            (click)="openAllStatuses()"
            matTooltip="Click to view all current and past updates"
            [matTooltipShowDelay]="1000"
            [matTooltipHideDelay]="2000"
            aria-haspopup="dialog"
            data-analytics="status-incidents-all-systems-operational">
            <h6>All systems operational</h6>
        </button>
        <ul>
            <li *ngFor="let link of incidents | slice: 0 : 3; let i = index; trackBy: trackByItem">
                <button
                    (click)="openIncident(link)"
                    [matTooltip]="'View ' + link.label + ' incidents'"
                    [matTooltipShowDelay]="1000"
                    [matTooltipHideDelay]="2000"
                    aria-haspopup="dialog"
                    [attr.data-analytics]="link.dataAnalytics?.join('-')">
                    {{ link.label }}
                </button>
            </li>
        </ul>
    </ng-container>

    <ng-template #contentLoading>
        <app-loading-skeleton [rows]="1" [rowHeight]="20"></app-loading-skeleton>
        <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
        <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
        <app-loading-skeleton [rows]="1" [rowHeight]="16"></app-loading-skeleton>
    </ng-template>
</ng-template>

<ng-template #actionsTemplate>
    <ng-container *ngIf="incidents$ | async as incidents; else actionsLoading"></ng-container>
    <button
        class="action link-btn"
        (click)="openAllUpdates()"
        matTooltip="View all current and past updates"
        [matTooltipShowDelay]="1000"
        [matTooltipHideDelay]="2000"
        aria-haspopup="dialog"
        data-analytics="status-incidents-view-all">
        View all updates
        <mat-icon [svgIcon]="'chevron_right'" aria-hidden></mat-icon>
    </button>

    <ng-template #actionsLoading>
        <app-loading-skeleton [rows]="1" [rowHeight]="18"></app-loading-skeleton>
    </ng-template>
</ng-template>
